// types
import { ReportColumnDto } from 'src/api';
// constants
import { singleSelectAggregationModels } from '../constants/aggregation-model/single-select';

export function ParticipationStatusColumn(index: number) {
  const column = {
    field: 'participationStatus',
    headerName: 'Partisipation status',
    description: 'Partisipation status column',
    type: 'singleSelect',
    index,
    width: 150,
    valueOptions: [
      'On time',
      'Too late',
      'Opted out',
      'Opted out too late',
      'On waiting list',
      'Signed up',
      'Never met',
    ],
    groupable: true,
    headerAlign: 'center',
    availableAggregationFunctions: singleSelectAggregationModels,
    align: 'center',
  } as ReportColumnDto<any, any, any>;
  return column;
}
